import * as React from 'react'
import styled from 'styled-components'
import { ViewBase } from '@bestyled/primitives'
import { commonProps, CommonProps } from '@bestyled/system'

export interface AspectRatioProps extends CommonProps {
  aspectRatio: number
}

export const AspectRatioStyled = styled(
  ViewBase<AspectRatioProps>('AspectRatioStyled')
)`
  position: relative;
  padding-bottom: ${(props) => `${100 * (1 / props.aspectRatio)}%`};
  overflow: hidden;
  ${commonProps}
`

const AutoFill = styled(ViewBase<any>('AutoFillView'))`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  & img {
    width: 100%;
    height: auto;
  }
`

/**  The AspectRatio component provides a container of a specified aspect ratio */
export const AspectRatio: React.FC<AspectRatioProps> = (props) => (
  <AspectRatioStyled {...props}>
    <AutoFill>{props.children}</AutoFill>
  </AspectRatioStyled>
)
